// i18n bootstrap for the admin app (react-i18next).
//
// Scope: the LOGGED-IN admin UI chrome (labels, buttons, menus). Switching is
// client-side and same-URL — the choice is persisted per-device in
// localStorage. It does NOT translate user data (job titles, candidate names,
// JD content) or backend-produced strings (API/validation/email text).
//
// To localize a string: add its key to locales/en.json (source of truth) plus
// es.json / ja.json, then render it with the `t()` hook from react-i18next.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import es from "./locales/es.json";
import ja from "./locales/ja.json";

export const SUPPORTED_LANGUAGES = [
    { code: "en", label: "English" },
    { code: "es", label: "Español" },
    { code: "ja", label: "日本語" },
];

export const LANG_STORAGE_KEY = "cp_admin_lang";

// Resolve the initial language: saved choice → browser preference → English.
// Wrapped in try/catch because localStorage can throw (private mode / blocked).
function resolveInitialLanguage() {
    try {
        const saved = window.localStorage.getItem(LANG_STORAGE_KEY);
        if (saved && SUPPORTED_LANGUAGES.some((l) => l.code === saved)) return saved;
    } catch (_e) {
        /* localStorage unavailable — fall through */
    }
    const nav = (typeof navigator !== "undefined" && (navigator.language || "")).slice(0, 2).toLowerCase();
    if (SUPPORTED_LANGUAGES.some((l) => l.code === nav)) return nav;
    return "en";
}

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: en },
        es: { translation: es },
        ja: { translation: ja },
    },
    lng: resolveInitialLanguage(),
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    interpolation: { escapeValue: false }, // React already escapes
    returnEmptyString: false, // fall back to en for empty/missing keys
});

// Persist the chosen language so it sticks across reloads on this device.
export function changeLanguage(code) {
    i18n.changeLanguage(code);
    try {
        window.localStorage.setItem(LANG_STORAGE_KEY, code);
    } catch (_e) {
        /* ignore — persistence is best-effort */
    }
}

export default i18n;
